import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from '../components/auth/Login';
import SignUp from '../components/auth/Signup';
import DoctorDashboard from '../components/doctor/Dashboard';
import OwnerDashboard from '../components/owner/OwnerDashboard';
import DoctorLayout from '../components/doctor/Layout';
import OwnerLayout from '../components/owner/Layout';
import { useAuth } from '../contexts/AuthContext';
import PlanManagement from '../components/owner/PlanManagement';
import DoctorManagement from '../components/owner/DoctorManagement';
import NewTranscription from '../components/transcription/NewTranscription';
import TranscriptionList from '../components/transcription/TranscriptionList';
import MyProfile from './MyProfile';

const LoadingSpinner = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    Carregando...
  </div>
);

const AppRoutes: React.FC = () => {
  const { isAuthenticated, user, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  // Se não estiver autenticado, só mostra rotas públicas
  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  // Se for médico
  if (user?.role === 'doctor') {
    return (
      <Routes>
        <Route element={<DoctorLayout />}>
          <Route path="/doctor/dashboard" element={<DoctorDashboard />} />
          <Route path="/doctor/transcription/new" element={<NewTranscription />} />
          <Route path="/doctor/transcriptions" element={<TranscriptionList />} />
          <Route path="/doctor/profile" element={<MyProfile />} />
        </Route>
        <Route path="*" element={<Navigate to="/doctor/dashboard" replace />} />
      </Routes>
    );
  }

  // Se for proprietário
  if (user?.role === 'owner') {
    return (
      <Routes>
        <Route element={<OwnerLayout />}>
          <Route path="/owner/dashboard" element={<OwnerDashboard />} />
          <Route path="/owner/plans" element={<PlanManagement />} />
          <Route path="/owner/doctors" element={<DoctorManagement />} />
          <Route path="/owner/profile" element={<MyProfile />} />
        </Route>
        <Route path="*" element={<Navigate to="/owner/dashboard" replace />} />
      </Routes>
    );
  }

  // Fallback para login
  return <Navigate to="/login" replace />;
};

export default AppRoutes;
